import {
  ButtonRoomControl,
  type ButtonRoomControlProps,
} from '@/components/ButtonRoomControl'
import { useSelfMemberState } from '@/hooks/useSelfMemberState'
import { useRoomStore, useRoomStoreActions } from '@/stores/room'

type OmittedProps = Omit<ButtonRoomControlProps, 'isActive' | 'onClick' | 'tag'>

type ButtonMicrophoneProps = OmittedProps

const ButtonMicrophone = ({
  disabled = false,
  isVisible = true,
  ...props
}: ButtonMicrophoneProps) => {
  const memberId = useRoomStore(state => state.memberId)
  const selfAudioMuted = useSelfMemberState({
    subscriptionKey: 'audioMuted',
  })
  const { audioMuteHandler } = useRoomStoreActions()

  return (
    <ButtonRoomControl
      disabled={disabled}
      isVisible={isVisible}
      isActive={!selfAudioMuted}
      onClick={() => audioMuteHandler(memberId)}
      tag={disabled ? 'mic-off-2' : 'mic'}
      {...props}
    >
      Microphone
    </ButtonRoomControl>
  )
}

export { ButtonMicrophone }
